import moment from 'moment-timezone';

/** Trading lockouts / cooldowns follow market timezone (same as trading windows). */
export const LOCKOUT_DISPLAY_TZ = 'America/New_York';

/**
 * Format a lockout expires_at timestamp for UI display.
 * Always America/New_York so Trading Rules, Alerts, and Account Health agree.
 *
 * @param {string|Date|null|undefined} iso
 * @param {'short'|'long'} [style='short']
 * @returns {string|null}
 */
export function formatLockoutExpiresAt(iso, style = 'short') {
  if (!iso) return null;
  const m = moment(iso).tz(LOCKOUT_DISPLAY_TZ);
  if (!m.isValid()) return null;

  if (style === 'long') {
    // e.g. "Tue, Aug 11, 4:00 PM EDT"
    return m.format('ddd, MMM D, h:mm A z');
  }

  // e.g. "4:00PM 08/11/26 EDT" — matches alerts-table shape, with explicit TZ
  return `${m.format('h:mmA')} ${m.format('MM/DD/YY')} ${m.format('z')}`;
}
